angular.module('app.accountSettings.transactionsListService', [])
  .factory('app.accountSettings.transactionsListService', [
    '$http',
    function ($http) {
      "use strict";

      let service = {
        list: null,
        error: null,
        retrieve: function () {
          return $http.get(window.location.api('my_account/data/transactions'))
            .then(
              function (response) {
                let data = response.data;
                service.list = null;

                if (data.error) {
                  service.error = data.error;
                }

                if (data.transactions) {
                  service.list = data.transactions;

                  for (let i = 0; i < service.list.length; i++) {
                    service.list[i].created_at = moment(service.list[i].created_at).toDate();
                  }
                }
              },
              function (response) {
                let data = response.data;

                if (data && data.error) {
                  service.error = data.error;
                }
                else {
                  service.error = 'Failed to retrieve transaction history.'
                }
              }
            );
        }
      };

      return service;
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/accountSettings/transactionsListService.js